<template>
  <v-card flat>
    <v-card-text>
      <v-row class="mx-auto mb-2" dense>
        <v-col>
          <span class="subtitle-2 font-weight-black">{{ $vuetify.lang.t(`$vuetify.map.criticalPopup.rejectedEvent.reason`) }}</span>
          {{
          $vuetify.lang.t(`$vuetify.map.criticalPopup.rejectDialog.states.${event.rejectReason}`) }}
        </v-col>
      </v-row>
      <v-row class="mx-auto my-2" dense v-if="isRetrainState">
        <v-col>
          <span class="subtitle-2 font-weight-black">{{ $vuetify.lang.t(`$vuetify.map.criticalPopup.rejectedEvent.retrain`) }}</span>
          {{ $vuetify.lang.t(`$vuetify.map.criticalPopup.title.${event.retrainState}`) }}
        </v-col>
      </v-row>
      <v-row class="mx-auto mt-2" dense v-if="event.rejectComment">
        <v-col>
          <v-textarea v-model="event.rejectComment" auto-grow outlined rows="3" readonly
                      :label="$vuetify.lang.t('$vuetify.map.criticalPopup.rejectDialog.rejectComment')"></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { CriticalEvent } from '../../../models/map/CriticalEvent'
import { UserCriticalEventRejection } from '../../../enum'

export default {
  name: 'critical-popup-rejected-event',
  props: {
    event: CriticalEvent,
  },
  computed: {
    isRetrainState () {
      return this.event.rejectReason === UserCriticalEventRejection.RETRAIN
    }
  }
}
</script>

<style scoped>

</style>
